<template>
  <a-modal
    ref="createModal"
    :title="title"
    width="80%"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    :footer="editIs ? undefined : null"
  >
    <a-spin :spinning="loading">
      <div class="title-text">材料汇总</div>
      <a-form-model ref="ruleForm" :model="formData">
        <a-row v-if="editIs">
          <a-col :span="8">
            <a-form-model-item label="领料类型" prop="requisitionType" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" :rules="requiredRules">
              <global-select
                v-model="formData.requisitionType"
                :selectData="pickTypeOptions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="16">
            <a-form-model-item label="说明" prop="remark" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
              <a-textarea v-model="formData.remark" allowClear :precision="4" :max-length="100" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <lsMetable
          ref="sumTableRef"
          :class="['editMaterial', { fixedSelectTable: editIs }]"
          :columns="columns"
          :data-list="showSumList"
          :scroll="sumTableScroll"
          :IsEdit="false"
          :need-add="false"
          rowKey="itemCode"
          :row-selection="sumRowSelection"
          :pagination="false"
        >
          <!-- 材料编码表头筛选 -->
          <template #itemCodeTitle>
            <ls-change-component2 title="材料编码" v-model="searchForm.itemCode" />
          </template>
          <!-- 大工序表头筛选 -->
          <template #bigProcessTitle>
            <ls-change-component2 title="大工序" v-model="searchForm.bigProcessKeyword" />
          </template>
          <template #bigProcessNames="{ record }">
            {{ record.bigProcessNames || record.bigProcessCodes || '未维护' }}
          </template>
          <!-- 材料名称表头筛选 -->
          <template #itemNameTitle>
            <ls-change-component2 title="材料名称" v-model="searchForm.itemName" />
          </template>
          <!-- 材料规格描述表头筛选 -->
          <template #specificationTitle>
            <ls-change-component2 title="材料规格描述" v-model="searchForm.specification" />
          </template>
          <template #pickingQtyTitle><span style="color: red">*</span>申请领料数量</template>
          <template #pickingQty="{ record }">
            <a-form-model-item v-if="editIs" :prop="'sumList.' + getSumListIndex(record) + '.pickingQty'" :rules="selectedRowKeys.includes(record.itemCode) ? requiredRules : []">
              <a-input-number v-model="record.pickingQty" allowClear :precision="4" />
            </a-form-model-item>
            <template v-else>{{ record.pickingQty }}</template>
          </template>
          <template #receivedQuantity="{ text, record }">
            <a href="javascript:;" @click="onShowRQDetail(record.id)">{{text}}</a>
          </template>
          <!--退料数量-->
          <template #backQty="{ text, record }">
            <a href="javascript:;" @click="onShowRQDetail(record.id)">{{text}}</a>
          </template>
          <template #operation="{ record }">
            <a-button type="link" @click="() => onGetDetailList(record)">查看详情</a-button>
          </template>
        </lsMetable>
      </a-form-model>
      <div class="title-text top-line">
        材料明细
        <a-button class="off-btn" type="link" @click="onCloseDetailList"><a-icon type="poweroff" /></a-button>
      </div>
      <lsMetable
        class="editMaterial"
        :columns="detailCols"
        :data-list="detailList"
        :scroll="{ y:300 }"
        :IsEdit="false"
        :need-add="false"
        :loading="detailLoading"
        :pagination="false"
      >
      </lsMetable>
      <ReceivedQuantityModal ref="receivedQuantityModalRef" />
    </a-spin>
    <a-space slot="footer">
      <template v-if="editIs">
        <a-button @click="onClose">取消</a-button>
        <a-button @click="onConfirm" :loading="confirmLoading" type="primary">确认提交</a-button>
      </template>
    </a-space>
  </a-modal>
</template>

<script>
import {
  apiGetMesRequisitionCcList,
  apiGetMoDetailList,
  apiGetMesRequisitionCcDetailList,
  apiProdPicking,
  apiGetRequisitionDetailList
} from '@/api/mes/workOrderManage/moTickets'
import ReceivedQuantityModal from '@/views/mes/workOrderManage/moTickets/components/received-quantity-modal.vue'
import lsChangeComponent2 from '@/components/LsChangeComponent/ls-change-component2.vue'
import { fixedTable } from 'lsmy-libs'

// 与 ls-api-table customSelection.columnWidth 保持一致
const SELECTION_COL_WIDTH = 61

export default {
  name: 'PickingModal',
  mixins: [fixedTable],
  components: {
    ReceivedQuantityModal,
    lsChangeComponent2
  },
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      confirmLoading: false,
      loading: false,
      visible: false,
      editIs: false,
      detailLoading: false,
      detailList: [],
      // 表单参数
      formData: {
        sumList: []
      },
      selectedRowKeys: [],
      selectedRows: [],
      // 材料汇总表头筛选条件
      searchForm: {
        itemCode: undefined,
        bigProcessKeyword: undefined,
        itemName: undefined,
        specification: undefined
      },
      title: '',
      moTicketCodeList: [],
      requiredRules: [{ required: true, message: ' ', trigger: 'change' }],
      baseData: {},
      pickTypeOptions: [],
      detailCols: [
        { dataIndex: 'wipEntityName', title: '工单号', width: 120 },
        { dataIndex: 'moTicketCode', title: 'MO票', width: 120 },
        { dataIndex: 'assemblyItemCode', title: '物料编码', width: 120 },
        { dataIndex: 'itemCode', title: '材料编码', width: 120 },
        { dataIndex: 'itemName', title: '材料各称', width: 150, ellipsis: true },
        { dataIndex: 'specification', title: '材料规格描述', width: 200, ellipsis: true },
        { dataIndex: 'quantityPerAssembly', title: '标准用量', width: 90 }
      ]
    }
  },
  computed: {
    // 材料汇总展示数据：根据表头输入框条件过滤，不影响原始 sumList
    showSumList() {
      const { itemCode, bigProcessKeyword, itemName, specification } = this.searchForm
      if (!itemCode && !bigProcessKeyword && !itemName && !specification) {
        return this.formData.sumList
      }
      return this.formData.sumList.filter(item => {
        let match = true
        // 材料编码过滤
        if (itemCode) {
          match = match && item.itemCode && item.itemCode.includes(itemCode)
        }
        // 大工序编码、名称过滤
        if (bigProcessKeyword) {
          const bigProcessText = `${item.bigProcessCodes || ''} ${item.bigProcessNames || ''}`
          match = match && bigProcessText.includes(bigProcessKeyword)
        }
        // 材料名称过滤
        if (itemName) {
          match = match && item.itemName && item.itemName.includes(itemName)
        }
        // 材料规格描述过滤
        if (specification) {
          match = match && item.specification && item.specification.includes(specification)
        }
        return match
      })
    },
    columns() {
      let list = [
        {
          dataIndex: 'itemCode',
          width: 100,
          ellipsis: true,
          scopedSlots: { title: 'itemCodeTitle' }
        },
        {
          dataIndex: 'bigProcessNames',
          width: 130,
          ellipsis: true,
          scopedSlots: { title: 'bigProcessTitle', customRender: 'bigProcessNames' }
        },
        {
          dataIndex: 'itemName',
          width: 150,
          ellipsis: true,
          scopedSlots: { title: 'itemNameTitle' }
        },
        {
          dataIndex: 'specification',
          width: 230,
          ellipsis: true,
          scopedSlots: { title: 'specificationTitle' }
        },
        { dataIndex: 'demandQty', title: '需求量', width: 90, ellipsis: true },
        {
          dataIndex: 'pickingQty',
          scopedSlots: { customRender: 'pickingQty', title: 'pickingQtyTitle' },
          width: 100
        },
        { dataIndex: 'receivedQuantity', title: '已领数量', width: 95, scopedSlots: { customRender: 'receivedQuantity' } },
        { dataIndex: 'backQty', title: '退料数量', width: 95, scopedSlots: { customRender: 'backQty' } },
        { dataIndex: 'operation', title: '操作', scopedSlots: { customRender: 'operation' }, width: 80 }
      ]
      if (this.editIs) {
        list = list.filter(item => item.dataIndex !== 'receivedQuantity' && item.dataIndex !== 'backQty')
      }
      return list
    },
    sumTableScroll() {
      const columnsWidth = this.columns.reduce((sum, col) => sum + (col.width || 100), 0)
      return {
        y: 300,
        x: columnsWidth + (this.editIs ? SELECTION_COL_WIDTH : 0)
      }
    },
    // 参考 ls-api-table customSelection.stickyFixed：用 CSS sticky 固定选择列，不用 ant fixed
    sumRowSelection() {
      if (!this.editIs) {
        return undefined
      }
      return {
        fixed: false,
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      }
    }
  },
  created() {
    this.getLookupList();
  },
  methods: {
    onCloseDetailList() {
      this.detailList = [];
    },
    onSelectChange(selectedRowKeys) {
      // Ant Design 受控模式下 onChange 的 selectedRowKeys 已包含不可见行的勾选
      // 仅需从完整 sumList 同步 selectedRows，避免筛选后提交/校验丢失隐藏行
      this.selectedRowKeys = selectedRowKeys
      this.syncSelectedRows()
    },
    // 从完整 sumList 同步 selectedRows，避免筛选后丢失隐藏行的勾选数据
    syncSelectedRows() {
      this.selectedRows = this.formData.sumList.filter(item =>
        this.selectedRowKeys.includes(item.itemCode)
      )
    },
    // 获取当前行在原始 sumList 中的索引，避免筛选后表单校验索引错位
    getSumListIndex(record) {
      return this.formData.sumList.findIndex(item => item.itemCode === record.itemCode)
    },
    resetSearchForm() {
      this.searchForm = {
        itemCode: undefined,
        bigProcessKeyword: undefined,
        itemName: undefined,
        specification: undefined
      }
    },
    show ({ moTicketCodeList, requisitionCode, title } = {}, editIs) {
      this.editIs = !!editIs;
      this.moTicketCodeList = moTicketCodeList || [];
      this.visible = true
      this.confirmLoading = false
      this.detailList = [];
      this.resetSearchForm();
      this.onSelectChange([], []);
      this.title = title || '发起领料'
      if(this.editIs) {
        this.getDataList(moTicketCodeList);
      }else {
        this.getMoDetail(requisitionCode)
      }
    },
    onGetDetailList(record) {
      if(this.editIs) {
        this.getEditDetailList(record);
      }else {
        this.getShowDetailList(record.id);
      }
    },
    getMoDetail(requisitionCode) {
      this.formData.sumList = [];
      this.loading = true;
      apiGetRequisitionDetailList({ requisitionCode }).then(res => {
        if(res.code === 200) {
          this.formData.sumList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 发起生产领料的时候查看材料
    getEditDetailList(record) {
      const { itemCode } = record;
      this.detailLoading = true;
      this.detailList = [];
      apiGetMesRequisitionCcDetailList({ itemCode, moTicketCodeList: this.moTicketCodeList }).then(res => {
        if(res.code === 200) {
          this.detailList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.detailLoading = false;
      })
    },
    // 查看详情-查看材料
    getShowDetailList(detailId) {
      this.detailLoading = true;
      this.detailList = [];
      apiGetMoDetailList({ detailId }).then(res => {
        if(res.code === 200) {
          this.detailList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.detailLoading = false;
      })
    },
    getDataList(moTicketCodeList) {
      this.formData.sumList = [];
      this.loading = true;
      apiGetMesRequisitionCcList(moTicketCodeList).then(res => {
        if(res.code === 200) {
          this.formData.sumList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.reset()
    },
    getParams() {
      if (!this.selectedRows.length) {
        this.$message.warning('请勾选数据')
        return null
      }
      // 勾选行可能被表头筛选隐藏，未挂载的表单项无法被 validate 校验，需单独校验
      if (!this.validateSelectedSumList()) {
        return null
      }
      let params = null;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          params = {
            ...this.formData,
            moTicketCodeList: this.moTicketCodeList,
            sumList: this.selectedRows
          }
        }
      })
      return params
    },
    // 单独校验勾选材料的必填项（含被筛选隐藏的行）
    validateSelectedSumList() {
      const invalidRow = this.selectedRows.find(row => {
        const pickingQty = row.pickingQty
        return pickingQty === null || pickingQty === undefined || pickingQty === ''
      })
      if (invalidRow) {
        this.$message.warning(`请填写材料【${invalidRow.itemCode}】的申请领料数量`)
        return false
      }
      return true
    },
    onShowRQDetail(id) {
      this.$refs.receivedQuantityModalRef.show(id)
    },
    onConfirm () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true
      this.$emit('update:mainBtnLoading', true);
      apiProdPicking(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('successCall')
          // 刷新表单
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$emit('update:mainBtnLoading', false);
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.formData = {
        sumList: []
      };
      this.detailList = [];
      this.resetSearchForm();
      this.onSelectChange([], []);
    },
    getLookupList() {
      const lookupQueryParams = {
        lookupType: 'MES_CC_REQUISITION_TYPE',
        current: 1,
        pageSize: 9999
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this.pickTypeOptions = response.rows || []
      })
    }
  }

}
</script>

<style  scoped lang="less">
/deep/.ant-input-number {
  width: 100%;
}
/deep/.ant-form-item {
  margin: 0
}
/deep/.ant-form-explain {
  position: absolute;
}
.title-text {
  font-size: 15px;
}
.top-line {
  border-top: #9faab1 solid 1px;
  margin-top: 8px;
}
.off-btn {
  float: right;
}
// 与 ls-api-table customSelection.stickyFixed 配套：选择列 CSS sticky，避免 ant fixed 表头错位
.fixedSelectTable {
  /deep/ .selection-column {
    position: sticky;
    left: 0;
    background: rgb(250, 250, 250);
    z-index: 1;
  }
  /deep/ .ant-table-selection-column {
    position: sticky;
    left: 0;
    background: white;
    z-index: 1;
  }
}
</style>
